/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPresentationOptionsMinRatioFromJSON, FxIdDomainSettingsPresentationOptionsMinRatioToJSON, } from './FxIdDomainSettingsPresentationOptionsMinRatio';
import { FxIdDomainSettingsPresentationOptionsMinSizeFromJSON, FxIdDomainSettingsPresentationOptionsMinSizeToJSON, } from './FxIdDomainSettingsPresentationOptionsMinSize';
import { FxIdDomainSettingsPresentationOptionsMaxSizeFromJSON, FxIdDomainSettingsPresentationOptionsMaxSizeToJSON, } from './FxIdDomainSettingsPresentationOptionsMaxSize';
import { FxIdDomainSettingsPresentationOptionsMaxRatioFromJSON, FxIdDomainSettingsPresentationOptionsMaxRatioToJSON, } from './FxIdDomainSettingsPresentationOptionsMaxRatio';
/**
 * Check if a given object implements the FxIdDomainSettingsPresentationOptions interface.
 */
export function instanceOfFxIdDomainSettingsPresentationOptions(value) {
    return true;
}
export function FxIdDomainSettingsPresentationOptionsFromJSON(json) {
    return FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'MinRatio': json['MinRatio'] == null ? undefined : FxIdDomainSettingsPresentationOptionsMinRatioFromJSON(json['MinRatio']),
        'MaxRatio': json['MaxRatio'] == null ? undefined : FxIdDomainSettingsPresentationOptionsMaxRatioFromJSON(json['MaxRatio']),
        'MinSize': json['MinSize'] == null ? undefined : FxIdDomainSettingsPresentationOptionsMinSizeFromJSON(json['MinSize']),
        'MaxSize': json['MaxSize'] == null ? undefined : FxIdDomainSettingsPresentationOptionsMaxSizeFromJSON(json['MaxSize']),
    };
}
export function FxIdDomainSettingsPresentationOptionsToJSON(json) {
    return FxIdDomainSettingsPresentationOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'MinRatio': FxIdDomainSettingsPresentationOptionsMinRatioToJSON(value['MinRatio']),
        'MaxRatio': FxIdDomainSettingsPresentationOptionsMaxRatioToJSON(value['MaxRatio']),
        'MinSize': FxIdDomainSettingsPresentationOptionsMinSizeToJSON(value['MinSize']),
        'MaxSize': FxIdDomainSettingsPresentationOptionsMaxSizeToJSON(value['MaxSize']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPresentationOptions.js.map